import { Component } from "react";
import { WifiOff } from "lucide-react";

export class ChunkBoundary extends Component {
  state = { err: null };
  static getDerivedStateFromError(err) { return { err }; }
  componentDidMount() { this.onPop = () => this.state.err && this.setState({ err: null }); window.addEventListener("popstate", this.onPop); }
  componentWillUnmount() { window.removeEventListener("popstate", this.onPop); }
  render() {
    const { err } = this.state;
    if (!err) return this.props.children;
    const offline = !navigator.onLine || /ChunkLoad|Loading chunk|dynamically imported/i.test(String(err?.name) + String(err?.message));
    return (
      <div className="min-h-[100dvh] grid place-items-center p-6 text-white bg-[#050522]" data-testid="chunk-error">
        <div className="max-w-sm text-center">
          <WifiOff className="w-10 h-10 mx-auto text-amber-300" />
          <h1 className="text-2xl font-black mt-3">{offline ? "This app isn't saved for offline yet" : "Something went wrong"}</h1>
          <p className="text-sm text-white/60 mt-2">{offline ? "Open it once while you're online and it will work offline next time." : "Please try again."}</p>
          <button onClick={() => { window.location.href = "/"; }} className="mt-5 px-5 py-2.5 rounded-xl font-black bg-gradient-to-r from-cyan-400 to-fuchsia-500" data-testid="chunk-error-home">Back to home</button>
        </div>
      </div>
    );
  }
}
